import Rollbar from 'rollbar';
import config from '../config'

class RollbarAPI {

    constructor({token}, Vue){

        if(config.production){

            // Set the Rollbar instance in the Vue prototype
            // before creating the first Vue instance.
            // This ensures it is available in the same way for every
            // instance in your app.
            Vue.prototype.$rollbarEventHandler = new Rollbar({
                accessToken: token,
                captureUncaught: true,
                captureUnhandledRejections: true,
            });

            // If you have already set up a global error handler,
            // just add `vm.$rollbar.error(err)` to the top of it.
            // If not, this simple example will preserve the app’s existing
            // behavior while also reporting uncaught errors to Rollbar.
            Vue.config.errorHandler = (err, vm, info) => {
                vm.$rollbarEventHandler.error(err);

                console.error(err, info);
                throw err; // rethrow
            };



        }

    }

    addMetadata(object){

        for(let [key, value] of Object.entries(object)){

            TrackJS.addMetadata(key, value);

        }

    }

}



export default class RollbarPlugin {

    static install(Vue, options = {}) {

        Vue.$rollbar = new RollbarAPI(options, Vue);

        Vue.prototype.$rollbar = Vue.$rollbar;

    }

}
